export default {
  payment: {}
};
